import logo from "../../../../img/logosmall.png"
import flagDE from "../../../../img/flags/4x3/de.svg"
import flagFR from "../../../../img/flags/4x3/fr.svg"

import { SYSAction, SYSScreen, ovl } from "../../../../../../../_ovlclient/src"
import {
  ScreenCurrent,
  ScreenNavigateTo,
} from "../../../../../../../_ovlclient/src/library/screenapi"
import { T } from "../../../../../../../_ovlclient/src/textapi"
import {
  HookSYSShellbarLanguages_Type,
  HookSYSShellbarMenu_Type,
} from "../../../../../../../_ovlclient/ovlsyscomponents/sysshellbar01/hooks"
import {
  FeatureInfo,
  PermissionHas,
} from "../../../../../../../_ovlclient/src/global/globalapi"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import { OfferingMainRefresh } from "../../../screens/qutoffering/offering/helpers"
import { SnackAdd } from "../../../../../../../_ovlclient/src/library/snackapi"

const HookSYSShellbarMenu: SYSAction<HookSYSShellbarMenu_Type> = (
  value,
  { global }
) => {
  switch (value.menuId) {
    case "User":
      value.result.items.push({
        description: T("GENUserSettingsTitle"),
        icon: "sap-icon--settings",
        handler: async () => {
          await ScreenNavigateTo("GENSettings")
        },
      })
      break
    case "Menu1":
      value.result.resultIcon = "sap-icon--menu2"
      let state = global.getState()
      if (
        FeatureInfo("DATQuotations") &&
        state.app.global.DAT.counts.quotationCount > 0
      ) {
        value.result.items.push({
          description: T("DATDocumentDataQuotationTitle"),
          icon: "sap-icon--tags",
          handler: (e) => ScreenNavigateTo("DATQuotation"),
        })
      }

      if (
        FeatureInfo("DATSalesOrders") &&
        state.app.global.DAT.counts.orderCount > 0
      ) {
        value.result.items.push({
          description: T("DATDocumentDataOrderTitle"),
          icon: "sap-icon--sales-order",
          handler: (e) => ScreenNavigateTo("DATOrder"),
        })
      }

      if (
        FeatureInfo("DATInvoices") &&
        state.app.global.DAT.counts.invoiceCount > 0
      ) {
        value.result.items.push({
          description: T("DATDocumentDataInvoiceTitle"),
          icon: "sap-icon--receipt",
          handler: (e) => ScreenNavigateTo("DATInvoice"),
        })
      }

      // Add the All KPIs link
      if (PermissionHas("KPIUS")) {
        // Assuming KPIUS permission is required for All KPIs view
        value.result.items.push({
          description: T("KPIAllTitle"),
          icon: "sap-icon--performance",
          handler: (e) => ScreenNavigateTo("KPIAll"),
        })
      }

      if (FeatureInfo("PKGPackaging")) {
        value.result.items.push({
          description: T("PKGPackagingPackaging"),
          icon: "sap-icon--product",
          handler: (e) => ScreenNavigateTo("PKGPackagingCustomerChooser"),
        })
      }
      if (
        FeatureInfo("QUTOfferingTool") ||
        FeatureInfo("QUTOfferingToolAdmin")
      ) {
        value.result.items.push({
          type: "separator",
          description: T("QUTOfferingMenuOfferingSeparatorCAD"),
        })
        value.result.items.push({
          description: T("QUTOfferingMenuOffering"),
          icon: "sap-icon--activate",
          handler: (e) => {
            //state.app.features.QUTOffering.offerMainType = "CAD"
            ScreenNavigateTo("QUTOffering", { instance: "CAD" })
          },
        })
      }
      if (FeatureInfo("QUTOfferingToolAdmin")) {
        value.result.items.push({
          description: T("QUTOfferingMenuOfferingAdmin"),
          icon: "sap-icon--activate",
          handler: (e) => {
            //state.app.features.QUTOffering.offerMainType = "CAD"
            ScreenNavigateTo("QUTOfferingAdmin", { instance: "CAD" })
          },
        })
      }

      if (
        FeatureInfo("QUTOfferingTool") ||
        FeatureInfo("QUTOfferingToolAdmin")
      ) {
        value.result.items.push({
          type: "separator",
          description: T("QUTOfferingMenuOfferingSeparatorCut"),
        })
        value.result.items.push({
          description: T("QUTOfferingMenuOffering"),
          icon: "sap-icon--activate",
          handler: async (e) => {
            //state.app.features.QUTOffering.offerMainType = "CUT"

            await getCutQualitiesLookup()
            ScreenNavigateTo("QUTOffering", { instance: "CUT" })
          },
        })
      }
      if (FeatureInfo("QUTOfferingToolAdmin")) {
        value.result.items.push({
          description: T("QUTOfferingMenuOfferingAdmin"),
          icon: "sap-icon--activate",
          handler: async (e) => {
            //state.app.features.QUTOffering.offerMainType = "CUT"
            await getCutQualitiesLookup()
            ScreenNavigateTo("QUTOfferingAdminCut", { instance: "CUT" })
          },
        })
      }

      if (FeatureInfo("SPCSymbolPC")) {
        value.result.items.push({
          description: T("SPCSymbolPCAdmin"),
          icon: "sap-icon--print",
          handler: (e) => ScreenNavigateTo("SPCSymbolPC"),
        })
      }
      if (FeatureInfo("SPCSymbolPCEndUser")) {
        value.result.items.push({
          description: T("SPCSymbolPCUserTitle"),
          icon: "sap-icon--print",
          handler: (e) => ScreenNavigateTo("SPCSymbolPCEndUser"),
        })
      }

      break
  }
}
const getCutQualitiesLookup = async () => {
  let cutQualities: { Code: string; Desc: string }[] = (
    await Data("offeringpos/lookups/quality")
  ).data
  let lookupState = ovl.getState().app.global.QUT.lookups.U_ImportSKL
  lookupState.data = cutQualities.reduce((val, k) => {
    val[k.Code] = { Code: k.Code }
    return val
  }, {})
}
const HookSYSShellbarLanguages: SYSAction<HookSYSShellbarLanguages_Type> = (
  value
) => {
  value.availableLanguages.forEach((lang) => {
    let pic
    switch (lang) {
      case "DE":
        pic = flagDE
        break
      case "FR":
        pic = flagFR
        break
    }
    value.result.items.push({ lang, pic })
  })
}

const HookSYSShellbarLogo: SYSAction = () => {
  return logo
}

export let hooks = {
  HookSYSShellbarLogo,
  HookSYSShellbarMenu,
  HookSYSShellbarLanguages,
}
